export default function () {
  const parentGrid = $('.product-grid-container ul.grid');
  const childItem = $(parentGrid).find('li.grid__item');

  $(childItem).each(function () {
    const btn = $(this).find('.mobile-quick-toggle img, .mobile-quick-toggle');

    $(btn).on('click', function () {
      $('.variant-selector').removeClass('active');
      $(this)
        .parents('.card-wrapper')
        .find('.variant-selector')
        .addClass('active');
    });

    const closeBtn = $(this).find('.variant-close');

    $(closeBtn).on('click', function () {
      $(this)
        .parents('.card-wrapper')
        .find('.variant-selector')
        .removeClass('active');
    });
  });
}
